import { Notification } from '@mantine/core'
import toast, { ToastBar, Toaster } from 'react-hot-toast'

export const ToastProvider = () => (
  <Toaster>
    {(t) => (
      <ToastBar
        toast={t}
        style={{
          padding: 0,
          minHeight: 0,
          minWidth: 0
        }}
      >
        {({ icon }) => (
          <Notification
            radius="md"
            className="min-h-[80px] w-full min-w-[400px]"
            color={
              t.className == 'Error'
                ? 'red'
                : t.className === 'Success'
                  ? 'green'
                  : 'blue'
            }
            icon={icon}
            title={t.className}
            onClose={() => toast.dismiss(t.id)}
            withBorder
            withCloseButton
          >
            {t.message?.toString()}
          </Notification>
        )}
      </ToastBar>
    )}
  </Toaster>
)
